import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { navigationSections } from '../config/navigation.js'

/**
 * Transform navigation config with localized labels
 * Following the pattern from cashloan module
 */
export function useNavigation() {
  const { t } = useI18n()

  const navSections = computed(() =>
    navigationSections.map((section) => ({
      title: section.titleKey ? t(section.titleKey) : '',
      items: section.items.map((item) => ({
        ...item,
        label: t(item.labelKey),
      })),
    }))
  )

  return { navSections }
}
